module.exports = __webpack_public_path__ + "img/reg-1.3c77ac20.jpg";